import FTourDictionary from '@/modules/Tour/Dictionary/index';

export default class FTourDictionaryDeparture extends FTourDictionary {
  dictionary = 'departure';


  __formatting({ departureCities = [] }) {
    return super.__formatting(departureCities);
  }
}
